import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { DcPhoneInput as Component } from './dc-phone-input';
import type { IPropsDcPhoneInput } from './models';

export const DcPhoneInput = createWidget<unknown, IPropsDcPhoneInput>({})(Component);
